<template>
  <div class="dashboard">
    <div class="header big-text">
      <!-- <span class="header__logo">] [</span> -->
      <div class="header__logo">
        <img src="static/logo_2026_onwards_sparse.png">
        <img src="static/logo_2026_onwards_sparse_slow.gif">
       </div>
      <div class="header__player-nowplaying-wrapper">
        <div class="header__player-nowplaying">
          <Player
              :audioUrl="reveilStream"
              playerId="sc"
              :endTime="endTime"
              :startTime="startTime"
            />
            &nbsp;
            <NowPlaying
            @resetScrollerPosition="resetScrollerPosition"
            :stream="streamNowPlaying"
            :endTime="endTime"
            :startTime="startTime"
            :reveilIsHappeningNow="reveilIsHappeningNow"
            />
          </div>
      </div>
      <div class="header__counters">
        <Timer :startTime="startTime" :endTime="endTime" />
        <span class="header__counters-spacer">&nbsp;</span>
        <Countdown 
        @change-reveil-is-happening-now="changeReveilIsHappeningNow"
        :startTime="startTime"
        :endTime="endTime"
        />
      </div>
      <div class="header__socials">
        <a href="http://soundtent.org/reveil.html" class="header__socials__reveil" target="_blank" style="margin-right: 10px;">Reveil 2–3 May 2026</a>
        <a href="https://www.instagram.com/sound_camp/" target="_blank">IG: sound_camp</a>
      </div>
    </div>
    <IRC />
    <Scroller 
      ref="scroller"
      @resetScrollerPosition="resetScrollerPosition"
      @setStreamNowViewing="setStreamNowViewing"
      @scrollToPageBottom="scrollToPageBottom"
      @selectStream="selectStream"
      :endTime="endTime"
      :startTime="startTime"
      :playingId="playingId"
      :selectedId="selectedId" 
      :viewingId="viewingId"
      :streams="streams" 
      :reveilIsHappeningNow="reveilIsHappeningNow"
      v-if="streams" 
    />
    <StreamInfo :stream="streamNowViewing"/>
    <div class="chat-label big-text">
      <span @click="scrollToPageBottom()">CHAT&nbsp;&nbsp;<img src="../assets/2x/arrowdown.png"></span>
    </div>
    <div class="footer" id="footer-anchor"></div> <!-- ensures bottom margin from streaminfo !-->
  </div>
</template>

<script>
import getStreams, { getEvent, pusher } from '@/api/api';
import NowPlaying from '@/components/NowPlaying';
import Scroller from '@/components/Scroller';
import TimeOfDay from '@/components/TimeOfDay';
import IRC from '@/components/IRC';
import StreamInfo from '@/components/StreamInfo';
import Player from '@/components/Player';
import Countdown from '@/components/Countdown';
import Timer from '@/components/Timer';

const reveilStream = process.env.NODE_ENV === 'development' ?
  'https://mp3s.nc.u-tokyo.ac.jp/OTANOMO_CyberForest.mp3' :
  'https://partneraudio.wavefarm.org/reveil.mp3';

export default {
  name: 'Dashboard',
  beforeRouteEnter: async (to, from, next) => {
    const [streams, event] = await Promise.all([getStreams(), getEvent()]);

    console.log(streams);
    for (var i=0;i<streams.length;i++) { //set feature text
      var featureCode = streams[i].attributes.featureCode;
      var featureText = "";

      if (featureCode == 1) { featureText="Coastal (e.g. beach, dunes)"; }
      else if (featureCode == 2) {featureText="Constructed or industrial (human-built, e.g. domestic spaces, buildings, factories)";}
      else if (featureCode == 3) {featureText="Cultivated agricultural, horticultural (frequently cultivated / ploughed / tilled land)";}
      else if (featureCode == 4) {featureText="Desert (little precipitation, e.g. Antarctica, Gobi Desert)";}
      else if (featureCode == 5) {featureText="Grasslands (dominated by grasses, other non-woody plants. Can also be managed, e.g. recreational fields)";}
      else if (featureCode == 6) {featureText="Heathland, scrub and tundra (dominated by shrubs, hedges, small trees. Can also be vineyards or orchards)";}
      else if (featureCode == 7) {featureText="Inland surface waters (e.g. lakes)";}
      else if (featureCode == 8) {featureText="Inland unvegetated or sparsely vegetated (less than 30% vegetation, e.g. caves, mines)";}
      else if (featureCode == 9) {featureText="Marine (e.g. the ocean or connected to the ocean)"; }
      else if (featureCode == 10) {featureText="Mires, bogs and fens (e.g. wetlands )"; }
      else if (featureCode == 11) {featureText="Urban greenery (vegetation surrounded by dense urban areas, e.g. gardens, parks, green roofs)."; }
      else if (featureCode == 12) {featureText="Woodland, forest and other wooded land (dominated by trees)"; }
      else if (featureCode == 13) {featureText="Other / Unknown"; }
      else {
        console.log("UNKNOWN FEATURE CODE for "+streams[i].attributes.location);
      }

      // if (featureCode == "H") { featureText="Stream, lake"; }
      // else if (featureCode == "L") {featureText="Park, area";}
      // else if (featureCode == "P") {featureText="City, village";}
      // else if (featureCode == "R") {featureText="Road, railroad";}
      // else if (featureCode == "S") {featureText="Spot, building, farm";}
      // else if (featureCode == "T") {featureText="Mountain, hill, rock";}
      // else if (featureCode == "U") {featureText="Undersea";}
      // else if (featureCode == "V") {featureText="Forest, heath";}
      // else if (featureCode == "A") {featureText="Country, state, region"; }
      streams[i].attributes.featureText = featureText;
    }

    next((vm) => {
      vm.setStreams(streams);
      vm.setEvent(event);
    });
  },
  mounted() {
  },
  created() {
    const channel = pusher.subscribe('now-playing');
    channel.bind('set', (data) => {
      console.log("Received now-playing set event from pusher with data: ");
      console.log(data);
      this.setNowPlaying(data.id);
    });
    channel.bind('unset', (data) => {
      console.log("Received now-playing unset event from pusher with data: ");
      console.log(data);
      if (this.playingId && this.playingId === data.id.toString()) {
        this.setNowPlaying(null);
      }
    });
  },
  components: {
    NowPlaying,
    Scroller,
    TimeOfDay,
    IRC,
    StreamInfo,
    Player,
    Countdown,
    Timer,
  },
  data() {
    return {
      endTime: this.endTime,
      streams: this.streams,
      streamNowPlaying: this.streamNowPlaying,
      streamNowViewing: this.streamNowViewing,
      viewingId: this.viewingId,
      selectedId: this.selectedId,
      selectedStream: this.selectedStream,
      startTime: this.startTime,
      playingId: this.playingId,
      scrollEndElement: this.scrollEndElement,
      currentlyScrolling: this.currentlyScrolling,
      reveilIsHappeningNow: this.reveilIsHappeningNow,
      reveilStream,
    };
  },
  methods: {
    setError() {
    },
    setEvent(event) {
      this.startTime = event.start;
      this.endTime = event.end;
    },
    setStreamNowViewing(id) {
      console.log("viewing "+id);
      if (!this.currentlyScrolling) {
        this.streamNowViewing = this.streams.find(stream=> stream.id === id);
        if (this.streamNowViewing) {this.viewingId = this.streamNowViewing.id; }
      }
    },
    changeReveilIsHappeningNow(boolVal) {
      this.reveilIsHappeningNow = boolVal;
    },
    resetScrollerPosition() {
      this.$refs.scroller.dragged = false;
      this.$refs.scroller.startInterval();
      this.streamNowViewing = this.streamNowPlaying;
      this.selectedStream = this.streamNowPlaying;

      if (this.streamNowViewing) {this.viewingId = this.streamNowViewing.id; }
      if (this.selectedStream) {this.selectedId = this.selectedStream.id; }

      // if (this.scrollStartElement) {
      //   this.scrollStartElement.scrollIntoView({behavior: 'smooth'});
      //   this.currentlyScrolling = true;
      //   setTimeout(function(scope){ scope.currentlyScrolling = false; }, 500,this);
      // }
    },
    selectStream(id) {
      this.selectedStream = this.streams.find(stream=> stream.id === id);
      this.streamNowViewing = this.selectedStream;

      if (this.streamNowViewing) {this.viewingId = this.streamNowViewing.id; }
      if (this.selectedStream) {this.selectedId = this.selectedStream.id; }

      console.log(this.selectedStream);

      if (this.scrollEndElement) {
        this.scrollEndElement.scrollIntoView({behavior: 'smooth'});
        this.currentlyScrolling = true;
        setTimeout(function(scope){ scope.currentlyScrolling = false; }, 500,this);
      }
    },

    setNowPlaying(id) {
      console.log("Setting now playing: "+id);

      if (!id) {
        this.streamNowPlaying = null;
        return;
      }

      this.streamNowPlaying = this.streams.find(stream => stream.id === id.toString());

      if (this.streamNowPlaying) {
        this.streamNowViewing = this.streamNowPlaying;
        this.viewingId = this.streamNowViewing.id;
      }
  
      if (!this.selectedStream || (this.selectedStream != undefined && this.playingId != undefined && this.playingId == this.selectedStream.id) ) {
        this.selectedStream = this.streamNowPlaying;
        this.selectedId = this.selectedStream.id;
      }

      this.playingId = id.toString();
    },
    setStreams(streams) {
      const streamNowPlaying = streams.find(stream => stream.attributes.nowPlaying);
      console.log("Stream now playing:");  
      console.log(streamNowPlaying);
      this.streams = streams;
      this.streamNowPlaying = streamNowPlaying;
      this.streamNowViewing = streamNowPlaying;
      this.selectedStream = streamNowPlaying;

      if (this.streamNowViewing) {this.viewingId = this.streamNowViewing.id; }
      if (this.selectedStream) {this.selectedId = this.selectedStream.id; }

      this.playingId = streamNowPlaying ? streamNowPlaying.id : undefined;
    },
    scrollToPageBottom() {
      window.scrollTo(0, document.body.scrollHeight);
    }
  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<!--        -->



// WEBPACK FOOTER //
// src/components/Dashboard.vue